import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class TypeOperationService {
  private apiUrl = '/typeoperations';
  private apiUrlSpring = '/spring/typeoperations';

  constructor(private http: HttpService) {}

  get(query?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiUrlSpring;
    return this.http.get(url, query);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/type-operation/type-operation.service.ts